<template>
<div>
  <HelloWorld v-if="!loaded && assetsLoaded"
    @clickedRSVP="onClickRSVP" />
  <DefaultMenu v-bind:activeTab="activeTab"
    v-on:update:activeTab="activeTab = $event"
    v-if="loaded && !editingMatchingRSVP" />
  <div class="page-container"
    v-if="loaded">
    <div id="modal-fadeInScale-fs"
      v-if="matchingRSVP && editingMatchingRSVP"
      class="modal modal-full-screen modal-fx-fadeInScale is-active edit-rsvp-modal"
      @keydown.esc="editingMatchingRSVP = false">
      <div class="modal-content modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{matchingRSVP.invitationName}}
            </br>
            <span @click="resetRSVP()"
              class="incorrect-rsvp">(<a>That's not me!</a>)</span>
          </p>
          <button @click="editingMatchingRSVP = false"
            class="modal-button-close delete"
            aria-label="close"
            :disabled="updatingRSVP"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns is-centered">
            <div class="column is-desktop is-fullwidth is-two-thirds-desktop">
              <div class="box attendees-form">
                <table v-if="!isMobile()"
                  class="table is-fullwidth is-hoverable">
                  <thead>
                    <tr>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Is attending?</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="rsvp in matchingRSVP.rsvps">
                      <td><input class="input"
                          type="text"
                          node_modules="First Name"
                          v-model="rsvp.firstName"></td>
                      <td><input class="input"
                          type="text"
                          placeholder="Last Name"
                          v-model="rsvp.lastName"></td>
                      <td><input class="input"
                          type="email"
                          placeholder="Email"
                          v-model="rsvp.email"></td>
                      <td><input class="input"
                          type="tel"
                          placeholder="Phone"
                          v-model="rsvp.phone"></td>
                      <td>
                        <div class="select">
                          <select v-model="rsvp.isAttending">
                            <option v-bind:value="true">Yes</option>
                            <option v-bind:value="false">No</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table v-if="isMobile()"
                  class="mobile table is-fullwidth is-hoverable">
                  <tbody>
                    <tr v-for="rsvp in matchingRSVP.rsvps">
                      <td @click="editRSVP(rsvp)">
                        <div class="attendee-view">
                          <div class="name">{{rsvp.firstName}} {{rsvp.lastName}}</div>
                          <div class="email"
                            v-bind:class="{'missing': !rsvp.email}">
                            <font-awesome-icon icon="envelope" /> {{rsvp.email}}
                          </div>
                          <div class="phone"
                            v-bind:class="{'missing': !rsvp.phone}">
                            <font-awesome-icon icon="phone" /> {{rsvp.phone}}
                          </div>
                          <span class="edit"><font-awesome-icon icon="edit"/></i></span>
                        </div>
                      </td>
                      <td>
                        <div class="select">
                          <select v-model="rsvp.isAttending">
                              <option v-bind:value="true">Yes</option>
                              <option v-bind:value="false">No</option>
                            </select>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <a @click="requestRSVPRow()"
                  v-if="matchingRSVP.canAddGuests"
                  class="button is-medium add-guests">Add Guest</a>
              </div>
              <div class="modal"
                v-bind:class="{'is-active': isEditingRSVP}"
                v-if="matchingRSVP && isEditingRSVP">
                <div @click="cancelRSVPRequest()"
                  class="modal-background"></div>
                <div class="modal-content">
                  <div class="container">
                    <div class="box">
                      <div class="field">
                        <label class="label">First Name</label>
                        <div class="control">
                          <input class="input"
                            type="text"
                            placeholder="First Name"
                            v-model="activeRSVP.firstName">
                        </div>
                      </div>
                      <div class="field">
                        <label class="label">Last Name</label>
                        <div class="control">
                          <input class="input"
                            type="text"
                            placeholder="Last Name"
                            v-model="activeRSVP.lastName">
                        </div>
                      </div>
                      <div class="field">
                        <label class="label">Email</label>
                        <div class="control">
                          <input class="input"
                            type="email"
                            placeholder="Email"
                            v-model="activeRSVP.email">
                        </div>
                      </div>
                      <div class="field">
                        <label class="label">Phone</label>
                        <div class="control">
                          <input class="input"
                            type="tel"
                            placeholder="Phone"
                            v-model="activeRSVP.phone">
                        </div>
                      </div>
                      <div class="field">
                        <label class="label">Is Attending?</label>
                        <div class="control">
                          <div class="select">
                            <select v-model="activeRSVP.isAttending">
                              <option v-bind:value="true">Yes</option>
                              <option v-bind:value="false">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="field is-grouped is-grouped-right">
                        <div class="control">
                          <button @click="confirmRSVPRequest()"
                            class="button is-link">Save</button>
                        </div>
                        <div class="control">
                          <button @click="cancelRSVPRequest()"
                            class="button is-text">Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button @click="cancelRSVPRequest()"
                  class="modal-close is-large"
                  aria-label="close"></button>
              </div>
              <div class="modal"
                v-bind:class="{'is-active': errorUpdatingRSVP}"
                v-if="errorUpdatingRSVP">
                <div class="modal-content">
                  <div class="container">
                    <div class="notification is-danger rsvp-error">
                      Whoops, this is embarassing.
                      <br>
                      <a :href="getRSVPMailTo()">Click here</a> to send you RSVP via email instead.
                    </div>
                  </div>
                </div>
                <button @click="errorUpdatingRSVP = false;"
                  class="modal-close is-large"
                  aria-label="close"></button>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <a @click="onUpdateRSVP()"
            class="button is-large is-primary is-fullwidth"
            v-bind:class="{'is-loading': updatingRSVP}"
            :disabled="updatingRSVP">Send RSVP</a>
        </footer>
      </div>
    </div>
    <parallax id="rsvp"
      class="page"
      :section-height="87">
      <div class="rsvp">
        <div class="rsvp-form columns is-centered is-vcentered"
          id="rsvp-scene">
          <div class="column is-three-quarters-mobile is-two-thirds-tablet is-half-desktop"
            v-if="!matchingRSVP">
            <div class="rsvp-helper-arrows"
              v-if="isMobile()">
              <span class="rsvp-helper-text">Enter your RSVP code here</span>
              <img src="./assets/arrows.png"
                alt="Enter RSVP Code here">
            </div>
            <div class="box rsvp-code-container">
              <div class="rsvp-code field has-addons">
                <div class="control">
                  <input ref="searchBox"
                    class="input"
                    type="text"
                    :placeholder="isMobile() ? 'RSVP CODE' : 'ENTER RSVP CODE'"
                    v-on:keyup.enter="onSearchRSVP()"
                    v-model="rsvpCode"
                    :disabled="loadingSearch">
                </div>
                <div class="control"
                  @click="onSearchRSVP()">
                  <a class="button is-info"
                    v-bind:class="{'is-loading': loadingSearch}"
                    :disabled="loadingSearch">
                    Search
                  </a>
                </div>
              </div>
              <div class="field"
                v-if="rsvpCodeIsInvalid">
                <p class="help is-danger">This RSVP code is invalid.</p>
              </div>
            </div>
          </div>
          <div v-if="matchingRSVP"
            class="column is-narrow animated rubberBand">
            <div class="box greeting">
              <div class="details">
                <div class="title">
                  {{!matchingRSVP.hasTouched ? 'You\'re invited!' : 'You\'re all set!'}}
                </div>
                <div class="subtitle">
                  {{!matchingRSVP.hasTouched ? 'to' : 'for'}}
                </div>
                <div class="header">
                  The Wedding of Heather &amp; Doug
                </div>
                <div class="date">
                  October 12th, 2019 @ <span class="time">4:00 PM</span>
                </div>
                <div class="address">
                  <div class="line-one">
                    La Costanera
                  </div>
                  <div class="line-one">
                    8150 Cabrillo Hwy
                  </div>
                  <div class="line-one">
                    Montara, CA 94037
                  </div>
                </div>
              </div>
              <div class="container">
                <div @click="editingMatchingRSVP = true"
                  class="notification level">
                  <div class="level-item">
                    <a class="button is-success has-text-centered is-medium animated bounce">
                      {{!matchingRSVP.hasTouched ? '' : 'Edit '}}RSVP
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <section id="hotels"
      class="hero"
      style="background-color: white;">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Lodging
          </h1>
          <h2 class="subtitle">
            a few options for where you should stay on your trip
          </h2>
          <div class="columns">
            <div class="column">
              <div class="box">
                <div class="subtitle"
                  id="airbnb">
                  AirBnB
                  <span class="tag is-success recommended-badge">Recommended</span>
                </div>
                <div class="details">
                  <span class="description">Hotels can be pricey, use <a :href="airBnbURL" target="_blank">AirBnB</a> to save some money by renting a house.
                    Below are some recommended neighborhoods in San Francisco. If the price ain't right, consider some nearby <a href="#suburbs">suburbs</a>.</span>
                  <ul class="neighborhoods">
                    <li class="tag is-rounded is-link"
                      v-for="neighborhood in recommendedNeighborhoods">
                      {{neighborhood}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div id="hotels"
                  class="subtitle">
                  Hotels
                </div>
                <div class="details">
                  <span class="description">Try and find a room at one of the below hotels. If the price ain't right, consider some nearby suburbs.</span>
                  <div class="hotels">
                    <HotelCarousel :hotel-group="recommendedHotels.standard" />
                    <HotelCarousel :hotel-group="recommendedHotels.basic" />
                    <HotelCarousel :hotel-group="recommendedHotels.budget" />
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div class="subtitle"
                  id="suburbs">
                  Suburbs
                </div>
                <div class="details">
                  <span class="description">You can save some money by staying just outside the city.</span>
                  <div class="suburbs">
                    <div class="">
                      <div class="suburb-area">
                        North Bay
                        <span class="price-estimate">
                          <font-awesome-icon icon="dollar-sign" />
                          <font-awesome-icon icon="dollar-sign" />
                        </span>
                      </div>
                      <div class="">
                        Beatiful and quaint harbor towns and mountains views. Need to cross the Golden Gate Bridge into the city (rarely has traffic but there is a toll).
                      </div>
                      <ul>
                        <li class="tag is-rounded is-link">Sausalito
                          <font-awesome-icon icon="car"
                            class="travel-option-icon"
                            title="travel via car" />
                          <font-awesome-icon icon="ship"
                            class="travel-option-icon"
                            title="travel via ferry" />
                        </li>
                        <li class="tag is-rounded is-link">Mill Valley
                          <font-awesome-icon icon="car"
                            title="travel via car"
                            class="travel-option-icon" />
                        </li>
                        <li class="tag is-rounded is-link">Tiberon
                          <font-awesome-icon icon="car"
                            title="travel via car"
                            class="travel-option-icon" />
                          <font-awesome-icon icon="ship"
                            title="travel via ferry"
                            class="travel-option-icon" />
                        </li>
                      </ul>
                    </div>
                    <div class="">
                      <div class="suburb-area">
                        East Bay
                        <span class="price-estimate">
                          <font-awesome-icon icon="dollar-sign" />
                        </span>
                      </div>
                      <div class="">
                        Need to cross Bay Bridge into the city. (Lots of traffic and small toll)
                      </div>
                      <ul>
                        <li class="tag is-rounded is-link">Berkeley
                          <font-awesome-icon icon="car"
                            title="travel via car"
                            class="travel-option-icon" />
                          <font-awesome-icon icon="ship"
                            title="travel via ferry"
                            class="travel-option-icon" />
                        </li>
                      </ul>
                    </div>
                    <div class="">
                      <div class="suburb-area">
                        South San Francisco
                        <span class="price-estimate">
                          <font-awesome-icon icon="dollar-sign" />
                        </span>
                      </div>
                      <div class="">
                        Beach towns along the west coast. Pockets of main streets. Epic views of the Pacific.
                      </div>
                      <ul>
                        <li class="tag is-rounded is-link">Pacifica
                          <font-awesome-icon icon="car"
                            title="travel via car"
                            class="travel-option-icon" />
                          <font-awesome-icon icon="ship"
                            title="travel via ferry"
                            class="travel-option-icon" />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <parallax class="page"
      :section-height="87">
      <img src="./assets/home_6.jpg"
        alt="vacation house">
      <div class="arrow up-right">
        <div class="">
          <span class="handwritten-label">Our family vacation house</span>
        </div>
        <img class=""
          src="./assets/down_left_arrow.png"
          alt="arrow pointing at vacation house">
      </div>
    </parallax>
    <section id="travel"
      class="hero"
      style="background-color: white;">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            FAQ
          </h1>
          <div class="">
            <FAQ title="What are the &quot;must see&quot; places?">
              <ul>
                <li>Golden Gate Park</li>
                <li>Lombard Street</li>
                <li>Muir Woods</li>
                <li>Cable Cars (use <a href="https://goo.gl/maps/KCog5m9LgPysWBsd6">Powell/Mason</a> to avoid lines)</li>
              </ul>
            </FAQ>
            <FAQ title="What other places are close to San Francisco?">
              <ul>
                <li>Napa Valley (1-2 Hours)</li>
                <li>Santa Cruz (1 Hour)</li>
                <li>Lake Tahoe (3 Hours)</li>
                <li>Yosemite (3.5 Hours)</li>
              </ul>
            </FAQ>
            <FAQ title="How far is LA?">
              About 6 hours away by car.
            </FAQ>
            <FAQ title="Do I need a car?">
              If you plan to stay in the city, you can use Lyft. If you plan to leave the city, we recommended renting a car.
            </FAQ>
            <FAQ title="What is the weather like in October?">
              The weather will be between 60°-70° fahrenheit during the day with a chance of breeze around any corner. It will drop to just below 60° at night.
            </FAQ>
            <FAQ title="What type of clothes should I pack?">
              The San Francisco outfit is typically a t-shirt with a sweatshirt over your shoulder in case of a breeze.
            </FAQ>
            <FAQ title="What are your favorite hiking trails?">
              <ul>
                <li><a href="https://www.alltrails.com/trail/us/california/lands-end-trail">Lands End Trail</a> - Epic Views of GGB + Ocean</li>
                <li><a href="https://www.alltrails.com/trail/us/california/rodeo-beach-coastal-trail-loop">Rodeo Beach</a> - Views of Ocean</li>
                <li><a href="https://www.alltrails.com/trail/us/california/fort-funston-trail">Fort Funston</a> - Views of Ocean from Cliff</li>
                <li><a href="https://www.alltrails.com/trail/us/california/muir-woods-trail">Muir Woods</a> - Views of Redwoods</li>
                <li><a href="https://www.alltrails.com/trail/us/california/cataract-falls-trail">Cataract Falls</a> - Views of Waterfall + SF + Ocean</li>
              </ul>
            </FAQ>
          </div>
        </div>
      </div>
    </section>
    <parallax class="page"
      :section-height="87">
      <img src="./assets/la_costanera_restaurant.jpg"
        alt="flights">
      <div class="arrow bottom-left">
        <div class="">
          <span class="handwritten-label">The Pacific Ocean</span>
        </div>
        <img class=""
          src="./assets/up_right_arrow.png"
          alt="arrow pointing at vacation house">
      </div>
      <div class="arrow bottom-right">
        <div class="">
          <span class="handwritten-label">The Wedding Venue</span>
        </div>
      </div>
    </parallax>
    <section id="schedule"
      class="hero"
      style="background-color: white;">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Schedule
          </h1>
          <h2 class="subtitle">an overview of the wedding events</h2>
        </div>
      </div>
      <div class="schedule">
        <div class="schedule-info columns is-desktop is-centered is-vcentered">
          <div class="column"
            v-if="matchingRSVP && matchingRSVP.canAttendSpecialEvents">
            <div class="dress-rehersal box">
              <div class="title">
                October 11, 2019
              </div>
              <div class="subtitle">
                The day before
              </div>
            </div>
            <div class="dress-rehersal box">
              <span class="time">07:00 PM</span>
              <div class="details">
                <div class="event">
                  <div class="subtitle">
                    Rehearsal Dinner
                  </div>
                  <div class="description">
                    Informal gathering in the backyard
                  </div>
                  <div class="address">
                    <div class="line">255 Marina Blvd</div>
                    <div class="line">San Francisco, CA 94123</div>
                  </div>
                  <div class="directions">
                    <a href="https://lyft.com/ride?id=lyft&destination[latitude]=37.806331&destination[longitude]=-122.436513">Request Lyft</a> | <a href="https://goo.gl/maps/yZ6SFrg6mwM2QW8FA">Get Directions</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column"
            v-bind:class="{'is-narrow': !matchingRSVP}">
            <div class="wedding-day box">
              <div class="title">
                October 12, 2019
              </div>
              <div class="subtitle">
                Wedding day
              </div>
            </div>
            <div class="wedding-day box">
              <span class="time">
                02:30 PM
              </span>
              <div class="details">
                <div class="event">
                  <div class="subtitle">
                    Shuttle to the Venue
                  </div>
                  <div class="description">
                    We'll drive you to the wedding.
                    <ul>
                      <li>Shuttles will wait in parking lot across the street. We will follow a scenic drive via Rt 1.</li>
                    </ul>
                  </div>
                  <article class="message is-warning">
                    <div class="message-header"></div>
                    <div class="message-body">
                      If you plan to arrive late, please travel directly to the venue.
                    </div>
                  </article>
                  <div class="address">
                    255 Marina Blvd, San Francisco, CA 94123
                  </div>
                  <div class="directions">
                    <a href="https://lyft.com/ride?id=lyft&destination[latitude]=37.806331&destination[longitude]=-122.436513">Request Lyft</a> | <a href="https://goo.gl/maps/yZ6SFrg6mwM2QW8FA">Get Directions</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="wedding-day box">
              <span class="time">
                04:00 PM
              </span>
              <div class="details">
                <div class="event">

                  <div class="subtitle">
                    Wedding Ceremony @ Venue
                  </div>
                  <div class="description">
                    We say 'I do', then we eat, drink, and dance.
                    <ul>
                      <li>Ceremony will be on the bottom floor.</li>
                      <li>Reception will follow on the main floor.</li>
                      <li>All guests will have access to the beach.</li>
                    </ul>
                  </div>
                  <div class="address">
                    La Costanera, 8150 Cabrillo Hwy, Montara, CA 94037
                  </div>
                  <div class="directions">
                    <a href="https://lyft.com/ride?id=lyft&destination[latitude]=37.806331&destination[longitude]=-122.436513">Request Lyft</a> | <a href="https://goo.gl/maps/yZ6SFrg6mwM2QW8FA">Get Directions</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="wedding-day box">
              <span class="time">
                11:30 PM
              </span>
              <div class="details">
                <div class="event">
                  <div class="subtitle">
                    After Party
                  </div>
                  <div class="description">
                    Celebration continues at the family vacation home!
                  </div>
                  <div class="address">
                    255 Marina Blvd, San Francisco, CA 94123
                  </div>
                  <div class="directions">
                    <a href="https://lyft.com/ride?id=lyft&destination[latitude]=37.806331&destination[longitude]=-122.436513">Request Lyft</a> | <a href="https://goo.gl/maps/yZ6SFrg6mwM2QW8FA">Get Directions</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column"
            v-if="matchingRSVP && matchingRSVP.canAttendSpecialEvents">
            <div class="brunch box">
              <div class="title">
                October 13, 2019
              </div>
              <div class="subtitle">
                The day after
              </div>
            </div>
            <div class="brunch box">
              <span class="time">
                12:00 PM
              </span>
              <div class="details">
                <div class="event">
                  <div class="subtitle">
                    Family Brunch
                  </div>
                  <div class="description">
                    Relax and enjoy brunch with the family
                  </div>
                  <div class="address">
                    255 Marina Blvd, San Francisco, CA 94123
                  </div>
                  <div class="directions">
                    <a href="https://lyft.com/ride?id=lyft&destination[latitude]=37.806331&destination[longitude]=-122.436513">Request Lyft</a> | <a href="https://goo.gl/maps/yZ6SFrg6mwM2QW8FA">Get Directions</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <parallax class="page"
      :section-height="90">
      <img src="./assets/heather+doug+beach.jpg"
        alt="heather and doug on the beach">
      <Honeymoon class="bottom-right" />
    </parallax>
  </div>
</div>
</template>

<script>
import bulmaCalendar from 'bulma-accordion';
import HelloWorld from './components/HelloWorld.vue';
import DefaultMenu from './components/DefaultMenu.vue';
import Honeymoon from './components/Honeymoon.vue';
import FAQ from './components/FAQ.vue';
import HotelCarousel from './components/HotelCarousel';
import parallax from 'vue-parallaxy';
import 'buefy/dist/buefy.css';
import 'animate.css/animate.css';
import {
  Howl,
  Howler
} from 'howler';
import axios from 'axios';

const SKIPPED_INTRO = 'skippedIntro';

var BASE_URL = 'https://lzlqaklsug.execute-api.us-east-1.amazonaws.com/production';
if (window.STAGE === 'local') {
  BASE_URL = 'http://localhost:3000';
} else if (window.STAGE === 'development') {
  BASE_URL = 'https://hs6wkjy9b2.execute-api.us-east-1.amazonaws.com/development';
}

var skippedIntro = localStorage.getItem(SKIPPED_INTRO) === 'true';

const recommendedNeighborhoods = [
  'Marina', 'Cow Hollow', 'Fishermans Wharf', 'Aquatic Park / Ft. Mason', 'North Beach', 'Union Street', 'Russian Hill', 'Pacific Heights', 'Telegraph Hill', 'Nob Hill',
];

const recommendedHotels = {
  standard: {
    category: 'Standard',
    dollarSigns: 3,
    hotels: [{
      id: 'sheraton',
      name: 'Sheraton',
      website: "https://www.marriott.com/hotels/travel/sfosi-sheraton-fishermans-wharf-hotel",
      address: {
        lineOne: "2500 Mason St",
        lineTwo: "San Francisco, CA 94133"
      },
      directions: "https://goo.gl/maps/qEPoyPyxUpv9i3RW8",
      imageUrl: require("./assets/sheraton-pool.jpg")
    }, {
      id: 'holiday-inn',
      name: 'Holiday Inn',
      website: "https://www.ihg.com/holidayinn/hotels/us/en/san-francisco/sfofw/hoteldetail",
      address: {
        lineOne: "495 Beach St",
        lineTwo: "San Francisco, CA 94133"
      },
      directions: "https://goo.gl/maps/FNm82koEwzH9uNiEA",
      imageUrl: require("./assets/holiday-inn-san-francisco-fishermans-wharf-holiday-inn-fishermans-wharf-pool.jpg")
    }]
  },
  basic: {
    category: 'Basic',
    dollarSigns: 2,
    hotels: [{
      id: 'hotel-del-sol',
      name: 'Hotel Del Sol',
      description: "Call and ask to speak with Tiffany. Mention 'The Colaizzo Wedding'",
      website: "https://www.jdvhotels.com/hotels/california/san-francisco/hotel-del-sol",
      address: {
        lineOne: "3100 Webster St",
        lineTwo: "San Francisco, CA 94123"
      },
      directions: "https://goo.gl/maps/8T5WECV5bQctB7ss8",
      imageUrl: require('./assets/hotel-del-sol.jpg'),
      altText: "hotel del sol pool",
      estimatedPrice: "250 / night"
    }, {
      id: 'cow-hollow-inn',
      name: 'Cow Hollow Inn',
      description: "Call and mention 'The Colaizzo Wedding'",
      website: "http://www.cowhollowmotorinn.com/",
      address: {
        lineOne: "2190 Lombard St",
        lineTwo: "San Francisco, CA 94123"
      },
      directions: "https://goo.gl/maps/maQiPMP48DARPyBSA",
      imageUrl: require("./assets/cow-hollow-inn.jpg"),
      altText: "cow hollow inn lounge",
      estimatedPrice: "260 / night"
    }]
  },
  budget: {
    category: 'Budget',
    dollarSigns: 1,
    hotels: [{
      id: 'hostel',
      name: 'Hosteling International - Fishermans Wharf',
      description: "Call and mention 'The Colaizzo Wedding'. Request private room.",
      website: "https://www.hiusa.org/hostels/california/san-francisco/fishermans-wharf",
      address: {
        lineOne: "240 Fort Mason",
        lineTwo: "San Francisco, CA 94123"
      },
      directions: "https://goo.gl/maps/3zLyuGEyc621WQgp6",
      imageUrl: require("./assets/hostel-view.jpg"),
      altText: "view from Hosteling International",
      estimatedPrice: "40 / person"
    }]
  },
};

export default {
  name: 'app',
  components: {
    HelloWorld,
    DefaultMenu,
    Honeymoon,
    parallax,
    FAQ,
    HotelCarousel,
  },
  data: function () {
    return {
      activeTab: 'rsvp',
      loaded: skippedIntro,
      assetsLoaded: false,
      GLOBAL_CONFIG: window.GLOBAL_CONFIG,
      rsvpCode: null,
      rsvpCodeIsInvalid: false,
      matchingRSVP: null,
      editingMatchingRSVP: false,
      loadingSearch: false,
      updatingRSVP: false,
      errorUpdatingRSVP: false,
      isEditingRSVP: false,
      activeRSVP: null,
      recommendedNeighborhoods,
      recommendedHotels,
      airBnbURL: "https://www.airbnb.com/s/San-Francisco--CA--United-States/all?refinement_paths%5B%5D=%2Ffor_you&query=San%20Francisco%2C%20CA%2C%20United%20States&toddlers=0&place_id=ChIJIQBpAG2ahYAR_6128GcTUEo&search_type=filter_change&checkin=2019-10-11&checkout=2019-10-13&adults=4",
    };
  },
  created: function () {
    this.updateAssetsLoaded();
  },
  mounted: function () {
    if (this.$route.query.code) {
      this.rsvpCode = this.$route.query.code;
    } else {
      this.rsvpCode = localStorage.getItem('rsvp-code');
    }

    if (this.loaded) {
      this.playBeachSounds();
      this.onLoaded();
    }
  },
  watch: {
    activeTab: function (tab) {
      if (tab === 'home') {
        this.loaded = false;

        localStorage.removeItem(SKIPPED_INTRO);

        this.stopBeachSounds();
      }
    },
    rsvpCode: function (rsvpCode) {
      if (rsvpCode) {
        localStorage.setItem('rsvp-code', rsvpCode);
      } else {
        localStorage.removeItem('rsvp-code');
      }
    },
    loaded: function () {
      this.onLoaded();
    },
    GLOBAL_CONFIG: {
      handler: function (GLOBAL_CONFIG) {
        this.updateAssetsLoaded();
      },
      deep: true
    }
  },
  methods: {
    onClickRSVP: function () {
      this.loaded = true;
      this.activeTab = 'rsvp';

      localStorage.setItem(SKIPPED_INTRO, true);

      this.playBeachSounds();
    },
    playBeachSounds: function () {
      this.sound = new Howl({
        src: ['/beach_audio_60.mp3'],
        volume: 0.8,
      });
      this.sound.play();
    },
    stopBeachSounds: function () {
      this.sound && this.sound.fade(1, 0, 2000);
    },
    updateAssetsLoaded: function () {
      if (this.GLOBAL_CONFIG.LOADING === false) {
        this.assetsLoaded = true;
      }
    },
    requestRSVPRow: function () {
      this.isEditingRSVP = true;
      this.activeRSVP = {
        invitationCode: this.matchingRSVP.invitationCode,
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
        isAttending: true,
        isNew: true,
      }
    },
    editRSVP: function (rsvp) {
      this.isEditingRSVP = true;
      this.activeRSVP = rsvp;
    },
    cancelRSVPRequest: function () {
      this.isEditingRSVP = false;
      this.activeRSVP = null;
    },
    confirmRSVPRequest: function () {
      this.isEditingRSVP = false;
      if (this.activeRSVP.isNew) {
        this.matchingRSVP.rsvps.push(this.activeRSVP);
      }
      this.activeRSVP = null;
    },
    resetRSVP: function () {
      this.rsvpCode = null;
      this.matchingRSVP = null;
      this.editingMatchingRSVP = false;

      let query = Object.assign({}, this.$route.query);
      delete query.code;
      this.$router.replace({
        query
      });
    },
    onSearchRSVP: function () {
      const rsvpCode = this.rsvpCode;

      this.loadingSearch = true;
      axios.get(`${BASE_URL}/api/rsvps?invitationCode=${rsvpCode}`)
        .then(response => {
          this.loadingSearch = false;
          this.matchingRSVP = response.data.rsvps[0];

          const rsvps = this.matchingRSVP.rsvps.map(r => {
            if (r.isAttending === null) {
              r.isAttending = true;
            }

            return r;
          });

          this.matchingRSVP.rsvps = rsvps;
          this.rsvpCodeIsInvalid = false;
        })
        .catch(e => {
          this.loadingSearch = false;
          this.rsvpCodeIsInvalid = true;
        });
    },
    onUpdateRSVP: function () {
      this.updatingRSVP = true;

      const id = this.matchingRSVP.id;
      axios.post(`${BASE_URL}/api/rsvps/${id}`, this.matchingRSVP)
        .then((response) => {
          this.updatingRSVP = false;
          this.errorUpdatingRSVP = false;
          this.matchingRSVP = response.data.rsvp;
          this.editingMatchingRSVP = false;

          window.location.hash = "#schedule";
        }).catch(e => {
          this.updatingRSVP = false;
          this.errorUpdatingRSVP = true;
        })
    },
    onLoaded: function () {
      if (this.loaded) {
        if (this.rsvpCode) {
          this.onSearchRSVP();
        }
      }
    },
    getRSVPMailTo: function () {
      var subject;
      var body;
      if (this.matchingRSVP) {
        subject = encodeURIComponent('[WEDDING RSVP]' + ' ' + this.matchingRSVP.invitationName);
        body = this.matchingRSVP.rsvps
          .map(r => r.firstName + ' ' + r.lastName + ' ' + (r.isAttending ? 'YES' : 'NO'))
          .map(r => encodeURIComponent(r))
          .join('%0D%0A');
      } else {
        subject = encodeURIComponent('[WEDDING_RSVP]');
      }

      return "mailto:dcolaizzo@gmail.com?subject=" + subject + "&body=" + body;
    },
    isMobile: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
          .test(a) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
          .test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);

      var isMobile = check || (window.innerWidth && window.innerWidth <= 800);

      return isMobile;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.fullscreen {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>

<style>
@font-face {
  font-family: 'Chalkduster2';
  src: url('assets/fonts/chalk.ttf') format('truetype');
}

.rsvp {
  background-image: url("./assets/la_costanera_ceremony_2.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
}

.schedule {
  background-image: url("./assets/map_1.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
}

.page-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  scroll-behavior: smooth;
}

.rsvp-form {
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  /* max-height: 80%; */
  /* margin-top: 100px; */
  background: none;
}

.rsvp-form .rsvp-code-container {
  margin-bottom: 175px;
}

.rsvp-form .rsvp-code input[type="text"] {
  background: transparent;
  border: none;
  border-color: white;
}

.rsvp-form .rsvp-code input[type="text"],
.rsvp-form .rsvp-code .button {
  font-size: 2.2em;
}

.rsvp-input,
.rsvp-button {
  background-color: transparent;
  border-color: white;
  color: white;
  text-transform: uppercase;
}

.rsvp-input-container {
  display: flex;
  justify-content: flex-start;
}

.rsvp-input {
  font-size: 2.5em;
}

.rsvp-input::placeholder {
  color: white;
  text-align: center;
}

.rsvp-input+placeholder {
  color: white;
  background-color: red;
}

.rsvp-button {
  font-size: 2.5em;
}

.rsvp-helper-arrows {
  text-align: center;
  position: relative;
}

.rsvp-helper-text {
  font-size: 1.6em;
  color: white;
  font-family: Chalkduster2;
}

.handwritten-label {
  color: white;
  font-family: Chalkduster2;
  font-size: 1em;
}

.arrow.up-right {
  position: absolute;
  right: 25%;
  top: 150px;
  width: 31px !important;
}

.arrow.bottom-left {
  position: absolute;
  left: 10%;
  top: 150px;
  width: 62px !important;
}

.arrow.bottom-right {
  position: absolute;
  right: 25%;
  bottom: 150px;
  width: 62px !important;
}

@media (max-width: 600px),
(max-height: 600px) and (orientation:landscape) {
  .rsvp-form .rsvp-code input[type="text"],
  .rsvp-form .rsvp-code .button {
    font-size: 1.2em;
  }

  .rsvp-helper-text {
    font-size: 1em;
  }

  .page:last-child {
    margin-bottom: 13vh;
  }

  .arrow.up-right {
    right: 10%;
  }

  .arrow.up-right {
    top: 130px;
  }
}

@media (max-width: 320px),
(max-height: 320px) and (orientation:landscape) {
  .rsvp-form .rsvp-code input[type="text"],
  .rsvp-form .rsvp-code .button {
    font-size: 1em;
  }
}

.greeting {
  background-color: rgba(255, 255, 255, 0.80);
}

.greeting .details {
  text-align: center;
}

.details .subtitle {
  margin-bottom: 0;
}

.greeting .details .header {
  font-size: 1.2em;
  font-weight: bold;
}

.greeting .details .date {
  margin-top: 1em;
}

.greeting .details .address {
  font-style: italic;
  margin-top: 1em;
}

.greeting .button:not(:first-child) {
  margin-left: 1em;
}

.greeting .notification {
  margin-top: 1em;
}

.schedule-info {
  margin: 1em 1em 1em 1em;
  padding: 1em 0;
}

.dress-rehersal,
.wedding-day,
.brunch {
  text-align: center;
}

.dress-rehersal .time,
.wedding-day .time,
.brunch .time {
  margin-top: 8px;
  margin-right: 8px;
  font-weight: bold;
  background-color: black;
  color: white;
  padding: 8px;
  border-radius: 1em;
}

.dress-rehersal .subtitle,
.wedding-day .subtitle,
.brunch .subtitle {
  font-weight: bold;
}

.dress-rehersal.box,
.wedding-day.box,
.brunch.box {
  padding: 12px;
}

.event {
  margin-top: 1em;
  margin-bottom: 1em;
}

.event .subtitle {
  margin-bottom: 5px;
}

.event .message {
  margin-top: 1em;
}

.event .message-header,
.event .message-body {
  padding: 4px;
}

.event .message-body {
  border-width: 2px;
  border-color: #ffdd57;
}

.event .address,
.event .directions {
  font-size: 0.8em;
  line-height: 0.8em;
  margin-top: 4px;
}

.schedule-info .address {
  margin-top: 1em;
}

.event .address .line {
  margin-top: 4px;
}

.description {
  font-style: italic;
}

.attendees-form {
  text-align: center;
}

.attendees-form .add-guests {
  margin-bottom: 1em;
}

.attendee-view {
  position: relative;
  cursor: pointer;
}

.attendee-view .edit {
  position: absolute;
  top: 0;
  right: 0;
  margin: 4px 4px 0 0;
}

.attendee-view .name {
  margin-left: 20px;
}

.attendee-view .email.missing,
.attendee-view .phone.missing {
  background-color: rgba(255, 255, 0, 0.15);
  border: 1px dashed rgba(231, 29, 54, 0.2);
}

.incorrect-rsvp {
  font-size: .5em !important;
}

.rsvp-error {
  font-size: 2em;
}

.modal-button-close:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.edit-rsvp-modal {
  background-color: rgba(0, 0, 0, .5);
}

.edit-rsvp-modal .modal-card-head {
  text-align: center;
}

.honeypot.bottom-right {
  margin-bottom: 160px;
}

.recommended-badge {
  float: right;
}

.hotel-badge {
  margin-left: 8px;
  margin-top: 8px;
}

.hotel-category,
.suburb-area {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: bold;
}

.tag {
  margin-top: 4px;
  margin-left: 4px;
  cursor: pointer;
}

.travel-option-icon {
  margin: 4px;
}

.neighborhoods,
.hotels,
.suburbs {
  margin-top: 1em;
}

.price-estimate {
  float: right;
  font-size: 1.2em;
}
</style>
